import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { SwitchFieldComponent } from './../../../switch-field.component';
import * as settings from './../../../../../common/settings';


@Component({
  selector: 'app-long-distance-field',
  templateUrl: './long-distance-field.component.html',
  styleUrls: ['./../../../Field-Styles.scss'],
})
export class LongDistanceFieldComponent extends SwitchFieldComponent implements OnInit {
  @Input() public RealValue;
  @Input() public Title: string = "Unset";

  @Input() MaxNumsAfterDot: number = 3;

  // write comp values
  @Input() ShowRealVal: boolean = false;
  @Input() MaxVal: number;
  @Input() MinVal: number;

  public units: settings.DisplayUnits = settings.userSettings.displayUnits;

  constructor() {
    super();
  }

  ngOnInit() {
  }
}
